import React, { PureComponent } from "react";

export default class SubMenuImage extends PureComponent {
  render() {
    return (
      <img src={this.props.url} className="img-fluid" alt={this.props.alt} />
    );
  }
}
